/* eslint-disable import/no-cycle */
import api from './api.service';

const BASE = '/campaigns/report/estimates';

function index(params) {
  return api.get(BASE, params);
}

function create(params) {
  return api.post(BASE, params);
}

function recalc(params) {
  return api.post(`${BASE}/recalc`, params);
}

function books(id, params) {
  return api.get(`${BASE}/${id}/books`, params);
}

function items(id, params) {
  return api.get(`${BASE}/${id}/items`, params);
}

// Report completo per libro, con intestazione
function exportReport(id) {
  return api.get(`${BASE}/${id}/export`);
}

// Stesso file degli ordini: isbn|quantita', separatore pipe, nessuna intestazione
function exportOrderFile(id) {
  return api.get(`${BASE}/${id}/export`, { format: 'order' });
}

export const estimatesService = {
  index,
  create,
  recalc,
  books,
  items,
  exportReport,
  exportOrderFile,
};
